import React, { Component } from 'react';
import GetUploadImage from './getUploadImage';
import Checkbox from '@material-ui/core/Checkbox';
import { confirmAlert } from 'react-confirm-alert';
class getRubros extends Component {
  constructor(props){
    super(props);
    this.state = {
        rubro : [],
        new_rubro :'',
        new_activo : 1,
        new_orden : 0
    }
  }
  cargar_rubros =()=>{
    const url= this.props.dir_url + "webapp/getDataRubro";
    const token =  this.props.token
    var obj = { accion:'datarubro', token};
    fetch(url, {
      method: 'POST',
      body: JSON.stringify(obj),
      headers:{
        'Accept':'application/json',
        'Content-Type': 'application/json'
      }
    })
    .then(res => res.json())
    .then((data) => {
      if(data[0].status==="ok"){
        //console.log(data)
        this.setState({
          rubro : data[0].msg
        })
      }
    })
    .catch(console.log)
  }
  regresar =()=>{
    this.props.get_salir_vista_pedido()
  }

get_opcion_no =()=>{

}

getnewrRubro =()=>{
  const rubro = this.state.new_rubro
  const activo = this.state.new_activo
  const orden  = this.state.new_orden
  if(rubro===''){
    alert("Ingrese Nombre Rubro")
    return
  }
  const url= this.props.dir_url + "webapp/getNewRubro";
  const token =  this.props.token
  var obj = { accion:'newrubro',token, rubro,activo,orden};
  fetch(url, {
    method: 'POST',
    body: JSON.stringify(obj),
    headers:{
      'Accept':'application/json',
      'Content-Type': 'application/json'
    }
  })
  .then(res => res.json())
  .then((data) => {
    this.props.get_loading(false)
    this.setState({
        new_rubro :'',
        new_activo : 1,
        new_orden : 0
    },()=>{
      this.cargar_rubros()
    })

  })
  .catch(console.log)
  this.props.get_loading(true)
}

getEliminarRubro=(id_acumulador)=>{
  confirmAlert({
    title: 'Eliminar Rubro',
    message: '¿Desea Eliminar Rubro?',
    buttons: [
      {
        label: 'Sí',
        onClick: () => {
          var rubro = this.state.rubro
          rubro.forEach(det => {
            if(Number(det.id_acumulador)===Number(id_acumulador)){
                det.eliminado = 1;
            }
          });
          this.setState(
            {rubro} , ()=>{
              this.getgrabarRubro(id_acumulador)
            }
          );

        }
      },
      {
        label: 'No',
        onClick: () => this.get_opcion_no()
      }
    ]
  })
}



  getgrabarRubro =(id_acumulador)=>{
    const array_rubro = this.state.rubro
    let rubro
    let activo
    let orden
    let eliminado
    let id_rubro

    array_rubro.forEach(det => {
      if(Number(det.id_acumulador)===Number(id_acumulador)){
        rubro = det.rubro
        orden = det.orden
        activo = det.activo
        eliminado = det.eliminado
        id_rubro = det.id_rubro
      }
    });
    if(Number(id_rubro)<=0){
      return null
    }
    const url= this.props.dir_url + "webapp/getGrabarRubro";
    const token =  this.props.token
    var obj = { accion:'grabarrubrodata',token, id_rubro,rubro,orden,activo,eliminado};
    fetch(url, {
      method: 'POST',
      body: JSON.stringify(obj),
      headers:{
        'Accept':'application/json',
        'Content-Type': 'application/json'
      }
    })
    .then(res => res.json())
    .then((data) => {
      this.props.get_loading(false)
      this.cargar_rubros()
    })
    .catch(console.log)
    this.props.get_loading(true)
  }
  getUUID =(uuid_imagen,id_rubro)=>{
    const url= this.props.dir_url + "webapp/getGrabarRubro";
    const token =  this.props.token
    var obj = { accion:'grabarrubro',token, uuid_imagen,id_rubro};
    fetch(url, {
      method: 'POST',
      body: JSON.stringify(obj),
      headers:{
        'Accept':'application/json',
        'Content-Type': 'application/json'
      }
    })
    .then(res => res.json())
    .then((data) => {
      this.props.get_loading(false)
      this.cargar_rubros()
    })
    .catch(console.log)
    this.props.get_loading(true)
  }
  handleChange_new = (event ,name) => {
    let value = event.target.value
    let checked = event.target.checked
    if(name==="rubro"){
      this.setState({
        new_rubro: value
      })
    }
    if(name==="orden"){
      this.setState({
        new_orden: value
      })
    }
    if(name==="activo"){
      this.setState({
        new_activo : (checked===true)?"1":"0"
      })
    }
  }
  handleChange = (event , index ,name) => {
    var rubro = this.state.rubro
    let value = event.target.value
    let checked = event.target.checked

    rubro.forEach(det => {
      if(Number(det.id_acumulador)===Number(index)){
        if(name==="rubro"){
          det.rubro = value;
        }
        if(name==="orden"){
          det.orden = value;
        }
        if(name==="activo"){
          det.activo = (checked===true)?"1":"0";
        }
      }
    });
    this.setState({rubro});
  }


  llenar_rubros =()=>{
    //console.log("actualizar")
    //id_rubro, rubro, orden, uuid_imagen, activo
    // file_500x200={this.props.file_500x200} file_250x200={this.props.file_250x200} file_60x60={this.props.file_60x60}
    //token_image
    //app-delivery-8b998-60x60 images%2F39295c1e-1cfb-4afd-adc2-4bc662f5f6e1
    //https://firebasestorage.googleapis.com/v0/b/app-delivery-8b998-250x200/o/images%2Fb5c56d54-4a34-4e9e-b3db-27ee28207c1e_250x200.png?alt=media&token=d79f2b7b-9479-4a31-841d-c47587722b95
    const url_image = this.props.url_image// "https://firebasestorage.googleapis.com/v0/b/"
    const separator = this.props.separator//"/o/images%2F"
    const file_xxx =this.props.file_250x200
    const token_image = url_image+file_xxx+separator
    const ext="_250x200.png?alt=media"
    const rubro = this.state.rubro
    return(
       <React.Fragment>
       <tbody>
        {
          (rubro)?
          rubro.map((det , index) => (
            <tr key={index}>
              <td>
              <table className="tb_pedidos">
                <thead>
                <tr>
                  <th>Campo</th>
                  <th>Valor</th>
                </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Id Rubro</td>
                    <td>{det.id_rubro}</td>
                  </tr>
                  <tr>
                    <td>Rubro</td>
                    <td> <input  type="text" value={det.rubro|| ''}
                      onChange={(e) => {this.handleChange( e , det.id_acumulador ,"rubro")}} /> </td>
                  </tr>
                  <tr>
                    <td>Activo</td>
                    <td>
                      <Checkbox
                        checked={(Number(det.activo)===0)?false:true}
                        onChange={(e) => {this.handleChange( e , det.id_acumulador ,"activo")}}
                        inputProps={{ 'aria-label': 'primary checkbox' }}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>Orden</td>
                    <td><input  type="text" value={det.orden|| ''}
                      onChange={(e) => {this.handleChange( e ,det.id_acumulador,"orden")}} /> </td>
                  </tr>
                </tbody>
              </table>
              </td>
              <td>
              <GetUploadImage uuid={det.id_rubro} file_xxx={this.props.file_250x200}  firebase={this.props.firebase} getUUID={this.getUUID}
              width={'250px'} height={'200px'} pref={'_250x200'}  token_image={
                (det.uuid_imagen)?
                token_image+det.uuid_imagen+ext:''
              } />
              </td>
              <td>
              <button style={{"width":"150px"}} className="button-global" onClick={ () => this.getgrabarRubro(det.id_acumulador)}>
                Grabar
              </button>
              <button style={{"width":"150px"}} className="button-global" onClick={ () => this.getEliminarRubro(det.id_acumulador)}>
                Eliminar
              </button>

              </td>
            </tr>
          )) :''
      }
      </tbody>
      </React.Fragment>
    )
  }
  render() {
    //<GetUploadImage file_xxx={'app-delivery-8b998-60x60'}  firebase={firebase} getUUID={this.getUUID} width={'60px'} height={'60px'}  token_image={''} />
    //id_datos_empresa, logo, datos_empresa, condiciones
    return(
      <React.Fragment>
      <div className="" style={{"backgroundColor":"white","color":"black"}}>
        <div className="grid-container_">
          <div className="lbl_imagen_" onClick={ () => this.regresar()}><img className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/12355707351582004488-128.png') } /></div>
          <div className="lbl_text_">Rubros</div>
        </div>
      </div>
      <div style={{"backgroundColor":"white","height":"100%","color":"black","overflowY": "auto"}}>
        <table className="tb_pedidos">
          <thead>
          <tr>
            <th>Campo</th>
            <th>Valor</th>
          </tr>
          </thead>
          <tbody>
            <tr>
              <td>Rubro</td>
              <td> <input  type="text" value={this.state.new_rubro}
                onChange={(e) => {this.handleChange_new( e ,"rubro")}} /> </td>
            </tr>
            <tr>
              <td>Activo</td>
              <td>
                <Checkbox
                  checked={(Number(this.state.new_activo)===0)?false:true}
                  onChange={(e) => {this.handleChange_new( e ,"activo")}}
                  inputProps={{ 'aria-label': 'primary checkbox' }}
                />
              </td>
            </tr>
            <tr>
              <td>Orden</td>
              <td><input  type="text" value={this.state.new_orden}
                onChange={(e) => {this.handleChange_new( e,"orden")}} /> </td>
            </tr>
            <tr>
              <td colSpan="2">
                <button style={{"width":"150px"}} className="button-global" onClick={ () => this.getnewrRubro()}>
                  Crear Nuevo Rubro
                </button>
              </td>
            </tr>
          </tbody>
        </table>


        <table className="tb_pedidos">
          <thead>
          <tr>
            <th>Información</th>
            <th>Imagen</th>
            <th>Opciones</th>
          </tr>
          </thead>
          {this.llenar_rubros()}
        </table>
        <br/><br/><br/><br/><br/>
      </div>
      </React.Fragment>
    )
  }
  //cargar_informacion
  componentDidMount (){
    this.cargar_rubros()
  }

}
export default getRubros;
